
import * as modals from "../../../lib/modals";
import Component from "vue-class-component";
import { getModule } from "vuex-module-decorators";
import InventoryModule from "@/store/modules/barcodeSystem/inventory";
import ModalMixin from "./mixin";
import ModelLinkSummary from "@/components/barcodeSystem/inventory/ModelLinkSummary.vue";
import notifications from "@/lib/notifications";
import { ModelLinkSummaryResource } from "@/models/api/barcodeSystem/inventory/modelLinkSummary";

const inventoryModuleState = getModule(InventoryModule);

@Component({
  name: modals.modelLinkSummaryModal,
  components: {
    ModelLinkSummary
  }
})
export default class ModelLinkSummaryModal extends ModalMixin {
  loadingComplete: boolean = false;
  modelLinkSummaryResource: ModelLinkSummaryResource = null;

  async load() {
    this.loadingComplete = false;
    this.show();

    let inventoryItem = this.selectedItems && this.selectedItems.length == 1 ? this.selectedItems[0] : null;

    if(inventoryItem == null)
      this.hideModal();

    try {
      let request = {
        facilityCode: inventoryItem.facilityCode,
        companyId: inventoryItem.companyId,
        manufacturerCode: inventoryItem.manufacturerCode,
        modelNumber: inventoryItem.modelNumber,
        poNumber: inventoryItem.poNumber
      };

      this.modelLinkSummaryResource = await inventoryModuleState.getModelLinkSumamry(request);
    } catch (ex) {
      notifications.error("Failed to load model link summary", "Failed to load model link summary.", ex);
      this.hideModal();
    }
    this.loadingComplete = true;
  }

  reset() {
    this.modelLinkSummaryResource = null;
    this.loadingComplete = false;
  }
}
